module.exports = __webpack_public_path__ + "img/logoYGS.1bdf6e22.png";